<template>
  <v-alert
    v-if="!isMinimumOrderTotalValid"
    :border="border"
    :color="color"
    :colored-border="coloredBorder"
    :dense="dense"
    :text="text"
    :type="type"
    class="mb-0 text-body-2 text-sm-body-1 brand-green-dark--text"
    v-bind="$attrs"
    v-on="$listeners"
  >
    {{ $t(`Cart.Message.Info.MinimumOrder.${sortText ? 'BodyAlt' : 'Body'}`, {minimumOrderTotalDiff: $options.filters.currency(minimumOrderTotalAmountDiff)}) }}
  </v-alert>
</template>

<script>

import PaymentMinimumOrderWarningMixin from '@/theme/default/components/payment/common/PaymentMinimumOrderWarning.js'

export default {
  name  : 'PaymentMinimumOrderWarning',
  mixins: [PaymentMinimumOrderWarningMixin],
  props : {
    color: {
      type   : String,
      default: 'brand-primary'
    }
  }
}
</script>

<style scoped src="@/theme/default/components/payment/common/PaymentMinimumOrderWarning.css"></style>

<style scoped>
</style>
